import React from 'react';
import { isTrue } from '../../helpers/isTrue';
import { checkValues } from './validation';
import _ from 'lodash';
import ReactSelect from '../../components/ReactSelect';
import { withTranslation } from 'react-i18next';
import { updateProfile } from '../Onboarding/components/queries';
import { showMessage } from '../../helpers/showMessage';
import Loading from '../../components/Loading';

class EditCompanyInfo extends React.Component {
    constructor(props) {
        super();

        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
        this.updateTaxIdTypes = this.updateTaxIdTypes.bind(this);
        this.updateCountries = this.updateCountries.bind(this);
        this.changeView = this.changeView.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onFocus = this.onFocus.bind(this);

        this.state = {
            isOpen: false,
            showEditMode: false,
            name: props.name ?? '',
            organization: props.organization ?? '',
            show_competitive_analysis: isTrue(props.show_competitive_analysis),
            geo_location: props.geo_location_value,
            tax_id: props.tax_id ?? '',
            tax_id_type: props.tax_id_type ?? '',
            tax_id_type_for_input: props.tax_id_type ?? '',
            company_address1: props.company_address1 ?? '',
            company_address2: props.company_address2 ?? '',
            billing_country: props.billing_country ?? '',
            billing_city: props.billing_city ?? '',
            billing_postal_code: props.billing_postal_code ?? '',
            errors: {},
            savedValues: {
                name: props.name ?? '',
                organization: props.organization ?? '',
                show_competitive_analysis: isTrue(props.show_competitive_analysis),
                geo_location: props.geo_location_value,
                tax_id: props.tax_id ?? '',
                tax_id_type: props.tax_id_type ?? '',
                tax_id_type_for_input: props.tax_id_type ?? '',
                company_address1: props.company_address1 ?? '',
                company_address2: props.company_address2 ?? '',
                billing_country: props.billing_country ?? '',
                billing_city: props.billing_city ?? '',
                billing_postal_code: props.billing_postal_code ?? '',
            },
        };
    }

    changeView(isEditMode) {
        this.setState({ showEditMode: isEditMode });
    }

    updateCountries(value) {
        this.setState({ geo_location: value });
    }

    updateTaxIdTypes(item) {
        this.setState({ tax_id_type: item.value, tax_id_type_for_input: item.id });
    }

    onChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
    }

    onChangeCheckBox() {
        this.setState({ show_competitive_analysis: !this.state.show_competitive_analysis });
    }

    onFocus(e) {
        const key = e.target.name;
        const errors = { ...this.state.errors };
        delete errors[key];

        this.setState({ errors });
    }

    async onSubmit(e) {
        try {
            // if we have no errors, the form from html will work
            const errors = checkValues(this.state, true);
            e.preventDefault();
            if (!_.isEmpty(errors)) {
                this.setState({ errors });
            } else {
                this.setState({
                    loading: true,
                });
                const params = {
                    tax_id: this.state.tax_id,
                    tax_id_type: this.state.tax_id_type,
                    company_address1: this.state.company_address1,
                    company_address2: this.state.company_address2,
                    billing_country: this.state.billing_country,
                    billing_city: this.state.billing_city,
                    billing_postal_code: this.state.billing_postal_code,
                    organization: this.state.organization,
                };

                const res = await updateProfile(params);
                const data = await res.json();
                if (res.status === 200) {
                    showMessage(data?.message ?? 'Information Updated', 'success');
                    this.setState({
                        savedValues: {
                            tax_id: this.state.tax_id,
                            tax_id_type: this.state.tax_id_type,
                            company_address1: this.state.company_address1,
                            company_address2: this.state.company_address2,
                            billing_country: this.state.billing_country,
                            billing_city: this.state.billing_city,
                            billing_postal_code: this.state.billing_postal_code,
                            organization: this.state.organization,
                        },
                    });

                    this.changeView(false);
                } else {
                    showMessage(data?.message ?? 'Something went wrong', 'error');
                }
            }
        } catch (err) {
            showMessage(err.message ?? 'Something went wrong', 'error');
            console.log(err);
        } finally {
            this.setState({
                loading: false,
            });
        }
    }

    render() {
        const { t } = this.props;

        const geo_locations = JSON.parse(this.props.geo_locations);
        let tax_id_types = JSON.parse(this.props.tax_id_types);
        const optionList = geo_locations.map((item) => ({ value: item.geo, label: item.location }));
        // add none type in options
        optionList.unshift({ value: '', label: 'None' });
        tax_id_types = tax_id_types.map((item) => ({
            ...item,
            // value: `${item.value}-${item.country_code}`,
            value: item.value,
            id: item.value,
        }));

        tax_id_types.unshift({ value: '', label: 'None' });

        const defaultLocation = this.props.geo_location_value
            ? { value: this.props.geo_location_value, label: this.props.geo_location }
            : { value: '', label: 'None' };

        const defaultTaxIdType = tax_id_types.find(
            (x) =>
                x.id === this.props.tax_id_type &&
                (this.props.tax_id_type === 'eu_vat'
                    ? this.props.tax_id.startsWith(x.country_code)
                    : true),
        ) ?? {
            value: '',
            label: 'None',
        };

        return (
            <>
                {/* form defined in html */}
                {this.state.showEditMode ? (
                    <>
                        <div className="edit-form inline" id="name-edit-inputs">
                            <div className="text-field mb-3 ml-0">
                                <label htmlFor="organization" className="form-label">
                                    {t('profile.main_info.company_name')}
                                </label>
                                <input
                                    name="organization"
                                    type="text"
                                    id="organization"
                                    className="form-control"
                                    onChange={this.onChange}
                                    value={this.state.organization}
                                    onFocus={this.onFocus}
                                />
                                {this.state.errors['organization'] && (
                                    <div className="error-message">
                                        {this.state.errors['organization']}
                                    </div>
                                )}
                            </div>
                        </div>
                        {!isTrue(this.props.is_superuser) && (
                            <>
                                <div className="edit-form inline" id="name-edit-inputs">
                                    <div
                                        className="text-field mb-3"
                                        style={{ marginRight: '10px' }}
                                    >
                                        <label htmlFor="vat-tax-id" className="form-label">
                                            {t('profile.main_info.vat_tax_id')}{' '}
                                        </label>
                                        <input
                                            name="tax_id"
                                            type="text"
                                            id="vat-tax-id"
                                            className="form-control"
                                            onChange={this.onChange}
                                            value={this.state.tax_id}
                                            onFocus={this.onFocus}
                                        />
                                        {this.state.errors['tax_id'] && (
                                            <div className="error-message">
                                                {this.state.errors['tax_id']}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-field mb-3">
                                        <label htmlFor="tax_id_type" className="form-label">
                                            {t('profile.main_info.tax_id_type')}{' '}
                                        </label>
                                        <input
                                            type="hidden"
                                            name="tax_id_type"
                                            value={this.state.tax_id_type_for_input}
                                        />
                                        <ReactSelect
                                            options={tax_id_types}
                                            // onChange={this.updateTaxIdTypes}
                                            customeOnChange={this.updateTaxIdTypes}
                                            isSearchable={true}
                                            blurInputOnSelect={true}
                                            defaultValue={defaultTaxIdType}
                                            classname="m-0"
                                            controlStyles={{ height: '45px' }}
                                            onFocus={() =>
                                                this.onFocus({ target: { name: 'tax_id_type' } })
                                            }
                                        />
                                        {this.state.errors['tax_id_type'] && (
                                            <div className="error-message">
                                                {this.state.errors['tax_id_type']}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="edit-form inline" id="name-edit-inputs">
                                    <div
                                        className="text-field mb-3"
                                        style={{ marginRight: '10px' }}
                                    >
                                        <label htmlFor="company_address1" className="form-label">
                                            {t('profile.main_info.company_address_1')}
                                        </label>
                                        <input
                                            name="company_address1"
                                            type="text"
                                            id="company_address1"
                                            className="form-control"
                                            onChange={this.onChange}
                                            value={this.state.company_address1}
                                            onFocus={this.onFocus}
                                        />
                                        {this.state.errors['company_address1'] && (
                                            <div className="error-message">
                                                {this.state.errors['company_address1']}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-field mb-3">
                                        <label htmlFor="company_address2" className="form-label">
                                            {t('profile.main_info.company_address_2')}
                                        </label>
                                        <input
                                            name="company_address2"
                                            type="text"
                                            id="company_address2"
                                            className="form-control"
                                            onChange={this.onChange}
                                            value={this.state.company_address2}
                                        />
                                    </div>
                                </div>
                                <div className="edit-form inline" id="name-edit-inputs">
                                    <div
                                        className="text-field mb-3"
                                        style={{ marginRight: '10px' }}
                                    >
                                        <label htmlFor="Billing Country" className="form-label">
                                            {t('profile.main_info.billing_country')}
                                        </label>
                                        <input
                                            name="billing_country"
                                            type="text"
                                            id="billing_country"
                                            className="form-control"
                                            onChange={this.onChange}
                                            value={this.state.billing_country}
                                            onFocus={this.onFocus}
                                        />
                                        {this.state.errors['billing_country'] && (
                                            <div className="error-message">
                                                {this.state.errors['billing_country']}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-field mb-3">
                                        <label htmlFor="billing_city" className="form-label">
                                            {t('profile.main_info.billing_city')}
                                        </label>
                                        <input
                                            name="billing_city"
                                            type="text"
                                            id="billing_city"
                                            className="form-control"
                                            onChange={this.onChange}
                                            value={this.state.billing_city}
                                            onFocus={this.onFocus}
                                        />
                                        {this.state.errors['billing_city'] && (
                                            <div className="error-message">
                                                {this.state.errors['billing_city']}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="edit-form inline" id="name-edit-inputs">
                                    <div
                                        className="text-field mb-3"
                                        style={{ marginRight: '10px' }}
                                    >
                                        <label htmlFor="billing_postal_code" className="form-label">
                                            {t('profile.main_info.billing_postal_code')}
                                        </label>
                                        <input
                                            name="billing_postal_code"
                                            type="text"
                                            id="billing_postal_code"
                                            className="form-control"
                                            onChange={this.onChange}
                                            value={this.state.billing_postal_code}
                                            onFocus={this.onFocus}
                                        />
                                        {this.state.errors['billing_postal_code'] && (
                                            <div className="error-message">
                                                {this.state.errors['billing_postal_code']}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="text-field mb-3"
                                        style={{ marginRright: '10px' }}
                                    ></div>
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <div className="user-details" id="name-user-details">
                        <div className="user-info row">
                            <strong className="col-md-4">
                                {' '}
                                {t('profile.main_info.company_name')}
                            </strong>
                            <span className="col">
                                {this.state.savedValues.organization || '-'}
                            </span>
                        </div>
                        <div className="user-info row">
                            <strong className="col-md-4"> {t('profile.main_info.location')}</strong>
                            <span className="col">
                                {this.state.savedValues.geo_location || '-'}
                            </span>
                        </div>
                        {!isTrue(this.props.is_superuser) && (
                            <>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.vat_tax_id')}
                                    </strong>
                                    <span className="col">
                                        {this.state.savedValues.tax_id || '-'}
                                    </span>
                                </div>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.tax_id_type')}
                                    </strong>
                                    <span className="col">{defaultTaxIdType?.label || '-'}</span>
                                </div>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.company_address_1')}
                                    </strong>
                                    <span className="col">
                                        {this.state.savedValues.company_address1 || '-'}
                                    </span>
                                </div>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.company_address_2')}
                                    </strong>
                                    <span className="col">
                                        {this.state.savedValues.company_address2 || '-'}
                                    </span>
                                </div>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.billing_country')}
                                    </strong>
                                    <span className="col">
                                        {this.state.savedValues.billing_country || '-'}
                                    </span>
                                </div>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.billing_city')}
                                    </strong>
                                    <span className="col">{this.props.billing_city || '-'}</span>
                                </div>
                                <div className="user-info row mb-2">
                                    <strong className="col-md-4">
                                        {' '}
                                        {t('profile.main_info.billing_postal_code')}
                                    </strong>
                                    <span className="col">
                                        {this.state.savedValues.billing_postal_code || '-'}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                )}

                <div className="buttons-wrapper">
                    {this.state.showEditMode ? (
                        <span id="name-edit-btns">
                            <button
                                type="button"
                                className="button button-outline button-primary button-icon"
                                onClick={() => this.changeView(false)}
                            >
                                <i className="icon-close"></i>
                            </button>
                            <button
                                type="submit"
                                className="button button-filled button-primary button-icon"
                                onClick={this.onSubmit}
                                disabled={this.state.loading}
                            >
                                {this.state.loading ? (
                                    <Loading onlyPreloader />
                                ) : (
                                    <i className="icon-check-icon"></i>
                                )}
                            </button>
                        </span>
                    ) : (
                        <button
                            type="button"
                            className="button button-filled button-primary button-icon"
                            id="name-edit-btn"
                            onClick={() => this.changeView(true)}
                        >
                            <i className="icon-edit"></i>
                        </button>
                    )}
                </div>
            </>
        );
    }
}

export default withTranslation()(EditCompanyInfo);
